import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'file360-required-label',
  templateUrl: './required-label.component.html',
  styleUrls: ['./required-label.component.scss']
})
export class RequiredLabelComponent implements OnInit {

  /**
   * Whether the required label should align to the right of the form (default is left)
   */
  @Input() alignRight: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
